import type { PaymentResultDetails } from './types';
import { formatCurrencyBRL, maskDocumentTail } from './paymentResultFormatters';
import styles from './PaymentDetailsCard.module.css';

export interface PaymentDetailsCardProps {
	details: PaymentResultDetails;
}

export const PaymentDetailsCard = ({ details }: PaymentDetailsCardProps) => {
	const rows = [
		{ label: 'Plano', value: details.planName },
		{ label: 'Método de Pagamento', value: details.paymentMethod },
		{ label: 'Data', value: details.date },
		{ label: 'Cliente', value: details.customerName },
		{ label: 'CPF/CNPJ do Cliente', value: details.customerDocument && maskDocumentTail(details.customerDocument) },
		{ label: 'Empresa', value: details.companyName },
		{ label: 'CNPJ da Empresa', value: details.companyDocument && maskDocumentTail(details.companyDocument) },
	].filter((row) => !!row.value);

	return (
		<div className={styles.card}>
			<div className={styles.amountRow}>
				<span className={styles.label}>Quantia</span>
				<span className={styles.value}>{formatCurrencyBRL(details.amount)}</span>
			</div>
			{rows.map((row) => (
				<div key={row.label} className={styles.row}>
					<span className={styles.label}>{row.label}</span>
					<span className={styles.value}>{row.value}</span>
				</div>
			))}
		</div>
	);
};
